import { configureStore } from 'election-stats-icu'

const store = configureStore({
  reducer: {}
})

export default store
